export default {
	"schedulecreate": {
		"pleaseFillAllInformations": "กรุณากรอกข้อมูลให้ครบถ้วน",
		"cancelDispatch": "ยกเลิกกำหนดการ",
		"rePlan": "วางแผนใหม่",
		"batchDispatch": "กำหนดการสินค้าแบบเทกอง",
		"routeNoStatus": "สถานะของคำสั่งจัดส่ง",
		"noDispatched": "ไม่มี",
		"dispatched": "จัดกำหนดการแล้ว",
		"closed": "ปิดแล้ว",
		"completed": "เสร็จสมบูรณ์แล้ว",
		"inTransit": "อยู่ระหว่างขนส่ง",
		"routeSource": "แหล่งที่มาของคำสั่งจัดส่ง",
		"oppositeAccount": "บัญชี TMS ของอีกฝ่ายหนึ่ง",
		"reNotification": "แจ้งอีกครั้ง",
		"confirmVehicle": "ยืนยันยานพาหนะ",
		"transportServiceDemand": "ข้อกำหนดบริการขนส่ง",
		"confirmAndDispatch": "ยืนยันและจัดส่ง",
		"acceptJob": "รับงาน",
		"acceptJobTips": "ท่านแน่ใจว่าจะรับงานหรือไม่",
		"dispatchInfo": "ข้อมูลการจัดกำหนดการ",
		"tickTips": "บริการที่เลือกสำหรับคำสั่งจัดส่ง ได้แก่",
		"summaryTips": "สรุปบริการเหล่านี้โดยคำสั่งขนส่ง",
		"noServicesTips": "ไม่มีการบริการ...",
		"projectMandatoryTips": "สินค้า/โครงการเป็นข้อมูลที่ต้องกรอก",
		"clickServiceSelectTips": "คลิ๊กข้อมูลการขนส่งด้านล่างเพื่อเลือกบริการที่เกี่ยวข้อง",
		"pleaseTips": "กรุณา",
		"selectServiceTips": "รายการบริการที่จำเป็นสำหรับคำสั่ง",
		"pleaseSelectWaybillTips": "กรุณาคลิ๊กข้อมูลการขนส่งในรายการด้านบน",
		"pleaseSelectRouteNo": "กรุณาเลือกคำสั่งจัดส่ง",
		"pleaseSelectNoDispatchedRouteNo": "ท่านสามารถเลือกได้เฉพาะคำสั่งที่ไม่ได้กำหนดไว้",
		"pleaseSelectCarrier": "กรุณาเลือกผู้ขนส่ง",
		"pleaseSelectConsignedProduct": "กรุณาเลือกสินค้าที่จัดส่ง",
		"batchDispatchTips": "การระบุกำหนดการแบบกลุ่ม",
		"batchDispatchSuccess": "ความสำเร็จของการจัดกำหนดการแบบกลุ่ม",
		"pleaseSpecifyVehicleInfo": "กรุณาระบุข้อมูลยานพาหนะ",
		"dispatchLetter": "หนังสือแจ้งกำหนดการ",
		"documentStatusIs": "สถานะเอกสารคือ",
		"unableToShow": "ไม่สามารถแสดงผลได้",
		"continueRePlan": "วางแผนใหม่ต่อไปหรือไม่?",
		"rePlanSuccess": "วางแผนใหม่สำเร็จ",
		"pleaseSelectOnlyOne": "กรุณาเลือกคำสั่งจัดส่ง (สามารถเลือกคำสั่งจัดส่งได้เพียงรายการเดียวเท่านั้น)",
		"cancelDispatchTips": "เพิกถอนกำหนดการต่อไปหรือไม่?",
		"cancelDispatchLetter": "เพิกถอนหนังสือแจ้งกำหนดการ",
		"cancelSuccess": "เพิกถอนกำหนดการสำเร็จ",
		"pleaseInputcorrectNo": "กรุณากรอกหมายเลขโทรศัพท์ของพนักงานขับรถที่ถูกต้อง!",
		"licenseHasExpired": "ใบขับขี่นี้หมดอายุแล้ว จะใช้พนักงานขับรถคนนี้หรือไม่",
		"fleetDisabled": "กลุ่มยานพาหนะนี้ถูกปิดใช้งาน จะใช้พนักงานขับรถคนนี้หรือไม่",
		"fleetDisabledTips": "กลุ่มยานพาหนะนี้ถูกปิดใช้งาน จะใช้ยานพาหนะคันนี้หรือไม่",
		"vehicleNotAnnualReview": "ยานพาหนะคันนี้ไม่ได้รับการตรวจสอบตามกำหนดเวลา จะใช้ยานพาหนะคันนี้หรือไม่",
		"vehicleInsuranceExpires": "ประกันภัยสำหรับยานพาหนะคันนี้หมดอายุแล้ว จะใช้ยานพาหนะคันนี้หรือไม่",
		"cannotSelect1": "พนักงานขับรถคนนี้ถูกปิดใช้งานและไม่สามารถเลือกได้",
		"cannotSelect2": "พนักงานขับรถคนนี้ไม่มีคะแนนและไม่สามารถเลือกได้",
		"cannotSelect3": "ยานพาหนะคันนี้ถูกปิดการใช้งานและไม่สามารถเลือกได้",
		"ownCar": "รถยนต์ของตนเอง",
		"individualDriver": "พนักงานขับรถ",
		"carrierSelectTips": "เมื่อผู้ขนส่งเลือกพนักงานขับรถเป็นรายบุคคลหรือมีพนักงานขับรถของตนเอง ท่านต้องกรอกข้อมูลยานพาหนะ",
		"driverNotNull": "ในรายการข้อมูลยานพาหนะ ข้อมูลพนักงานขับรถไม่สามารถเป็นค่าว่างได้",
		"driverPhoneNoNotNull": "ในรายการข้อมูลยานพาหนะ หมายเลขโทรศัพท์มือถือของพนักงานขับรถไม่สามารถเป็นค่าว่างได้",
		"vehicleTypeNotNull": "ในรายการข้อมูลยานพาหนะ รุ่นของยานพาหนะไม่สามารถเป็นค่าว่างได้",
		"plateNoNotNull": "ในรายการข้อมูลยานพาหนะ ป้ายทะเบียนรถไม่สามารถเป็นค่าว่างได้",
		"dispatchSuccess": "จัดส่งสำเร็จ",
		"noVehicleInfoTips": "ไม่มีข้อมูลยานพาหนะ! ท่านยืนยันว่าไม่ต้องการข้อมูลยานพาหนะ ?",
		"vehicle": "ยานพาหนะ",
		"paperStyle": "ตัวอย่างใบส่งของ",
		"minSizeGtMsg": "คำสั่งจัดส่งประกอบด้วยคำสั่งจัดส่งหลายรายการ ไม่สามารถเลือกยานพาหนะหลายคันได้!",
		"planInfo": "ข้อมูลแผน",
		"pleaseSelectOnlyOne2": "ท่านสามารถเลือกรุ่นรถบรรทุกได้ประเภทเดียวเท่านั้นเมื่อส่งคำสั่งหลายรายการ",
		"addVehicle": "เพิ่มยานพาหนะ",
		"vehicleInfoTips": "ค้นหาข้อมูลยานพาหนะ",
		"searchTrackerTips": "ค้นหาข้อมูลระบบติดตามการดำเนินงาน",
		"newCapacityDriver": "พนักงานขับรถใหม่ในกลุ่มยานพาหนะ",
		"newCapacityMobile": "เบอร์โทรศัพท์ของพนักงานขับรถ",
		"newCapacityVehicleType": "รถรุ่นใหม่ในกลุ่มยานพาหนะ",
		"newCapacityPlateNo": "ป้ายทะเบียนใหม่ในกลุ่มยานพาหนะ",
		"newCapacityCertificateNo": "หมายเลขใบรับรองใหม่ในกลุ่มยานพาหนะ",
		"selectDriver": "เลือกคนขับ",
		"selectContactNumber": "เลือกเบอร์โทรศัพท์",
		"selectActualVehicleType": "เลือกประเภทรถวิ่งจริง",
		"selectTrailerType": "เลือกประเภทหาง",
		"selectPlateNumber": "เลือกทะเบียน",
		"selectLicenseNumber": "เลือกเลขใบขับขี่",
		"selectProvincialSign": "เลือกป้ายจังหวัด",
		"live": "ข้อมูลแบบเรียลไทม์",
		"noTemperature": "ไม่มีอุณหภูมิ",
		"numberData": "สินค้า!",
		"atLeastKeep": "อย่างน้อย",
		"senderCity": "เมือง/เขตที่ขนส่งสินค้า",
		"receiverCity": "เมือง/เขตที่รับสินค้า",
		"cancelWaybillTips": "ท่านแน่ใจว่าจะยกเลิกใบจัดส่งสินค้าหรือไม่?",
		"downloadRouteNo": "ดาวน์โหลดใบส่งของ",
		"mustPickingUpGoods": "ต้องมีใบรับสินค้าเมื่อรับสินค้า",
		"downloadDeliverygoods": "ดาวน์โหลดใบรับสินค้า",
		"otherDocument": "ไฟล์อื่น ๆ",
		"clickDownloadTips": "หากท่านต้องการข้อมูลเหล่านี้ กรุณาคลิ๊กเพื่อดาวน์โหลด",
		"downloadAll": "ดาวน์โหลดทั้งหมด",
		"bill": "คำสั่ง",
		"job": "งาน",
		"billNo": "เลขที่คำสั่ง",
		"download": "ดาวน์โหลด",
		"invalidFileObject": "ประเภทไฟล์ไม่ถูกต้อง",
		"handoverSheet": "โอนคำสั่ง",
		"noSend": "ไม่ได้ส่ง",
		"send": "ส่ง",
		"emailSubject": "หัวข้ออีเมล์",
		"inputEmailSubject": "กรุณากรอกหัวข้ออีเมล์",
		"shortMessageInfo": "เนื้อหา SMS",
		"reason": "เหตุผลที่เปลี่ยนประเภทรถ",
		"truck": "รถบรรทุกหัว",
		"addTruck": "เพิ่มรถบรรทุกหัว",
		"trailer": "รถบรรทุกหาง",
		"addTrailer": "เพิ่มรถบรรทุกหาง",
		"subcontractorTruck": "ผู้ให้บริการ",
		"subcontractorTrailer": "ผู้ให้บริการ",
		"trailerTypeRequired": "ประเภทหางลากจำเป็นต้องกรอก",
		"plateNumberRequired": "หมายเลขทะเบียนจำเป็นต้องกรอก",
		"trailerProvincialSignRequired": "ป้ายจังหวัดจำเป็นต้องกรอก",
		"driverRequired": "พนักงานขับรถจำเป็นต้องกรอก",
		"contactNumberRequired": "หมายเลขติดต่อจำเป็นต้องกรอก",
		"actualVehicleTypeRequired": "รุ่นรถจำเป็นต้องกรอก",
		"licencseNumberRequired": "หมายเลขใบอนุญาติจำเป็นต้องกรอก",
		"truckProvincialSignRequired": "ป้ายจังหวัดจำเป็นต้องกรอก",
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/schedule/schedule.js